module.exports = __webpack_public_path__ + "img/RW.6cab60c3.svg";